import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesFoodIntakeAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesFoodIntakeAction() {
  return fetchApi('/v1/fc_api/feeding_guidelines_food_intake_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesFoodIntakeAction;
